import { useCallback } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { CreateRecordingBody, createRecordingResponseSchema } from '@minutes-system/backend/src/api/recordings/schema';
import { guardedClient } from '../../auth/api/clients';
import fetchAndValidate from '../../../lib/fetchAndValidate';
import { customersQueryAtom, buildQueryKey } from '../../../states/customers';
import { advisorsQueryAtom, buildAdvisorsQueryKey } from '../../../states/advisors';
import { recordingsAtom } from '../../recordings/list/states/state';

const useUploadRecordings = () => {
  const { customers } = useAtomValue(customersQueryAtom(buildQueryKey({})));
  const { advisors } = useAtomValue(advisorsQueryAtom(buildAdvisorsQueryKey({})));
  const refreshRecordings = useSetAtom(recordingsAtom);

  const createRecording = useCallback(async (data: CreateRecordingBody) => {
    const response = await guardedClient.recordings.$post({ json: data });
    return await fetchAndValidate(Promise.resolve(response), createRecordingResponseSchema);
  }, []);

  const deleteRecording = useCallback(async (id: number) => {
    await guardedClient.recordings[':id'].$delete({
      param: { id: String(id) },
    });
  }, []);

  return { advisors, customers, createRecording, deleteRecording, refreshRecordings };
};

export default useUploadRecordings;
